// extracted by mini-css-extract-plugin
module.exports = {"body":"SmallButton_body__2fY5w","bodyOutline":"SmallButton_bodyOutline__3Wk2-"};